module.exports={
  "id": "quick-bites-and-bevs",
  "name": "Quick bites and bevs",
  "subtext": "Enjoy this convenient, all-in-one package with fresh fruit,  assorted nuts, nut bars, coffee, energy drinks, and more.",
  "coverImage": "https://img.peerspace.com/image/upload/v1725383524/spiwpjszone5o3cm9lbe.jpg",
  "price": {
    "value": 29.0,
    "per_person": true
  },
  "menu": {
    "menu_sections": [
      {
        "id": "quick-bites-included",
        "title": "Includes",
        "description": "Fruit display, assorted nuts, nut bars, and chips. For beverages: bottled water, bottle coffee, and an energy drink."
      }
    ]
  },
  "description": "Includes: Fruit display, assorted nuts, nut bars, and chips. For beverages: bottled water, bottled coffee, and an energy drink."
}
